import * as PIXI from 'pixi.js';
import { SCREEN_PADDING_PERCENT } from '../Renderer';
import {
  getAlignX,
  getAlignY,
  getCenterX,
  getCenterY,
  getFixBottomY,
  getFixLeftX,
  getFixRightX,
  getFixTopY,
} from './CoordinateCalculator';

/**
 * Our container builds on top of Pixi.Container, and provides a
 * "parent" wrapper which is never moved or scaled.
 */
export default class Container {
  constructor(app) {
    this.app = app;

    // parent is always fixed
    this.parent = new PIXI.Container();
    this.parent.width = app.screen.width;
    this.parent.height = app.screen.height;

    // container can be scaled, moved, etc.
    this.container = new PIXI.Container();
    this.container.width = app.screen.width;
    this.container.height = app.screen.height;

    this.parent.addChild(this.container);
  }

  getRelativePosition(root, { x, y }, padding = SCREEN_PADDING_PERCENT) {
    let horizontal, vertical;
    const pixelMathAllowance = 2;

    if (typeof x === 'string') {
      horizontal = x;
    } else if (
      Math.abs(
        getFixLeftX(root, this.app.screen, padding, this.app.screen.height) - x
      ) < pixelMathAllowance
    ) {
      horizontal = 'left';
    } else if (
      Math.abs(
        getFixRightX(root, this.app.screen, padding, this.app.screen.height) - x
      ) < pixelMathAllowance
    ) {
      horizontal = 'right';
    } else if (
      Math.abs(getCenterX(root, this.app.screen, padding) - x) <
      pixelMathAllowance
    ) {
      horizontal = 'center';
    } else {
      horizontal = x / this.app.screen.width;
    }

    if (typeof y === 'string') {
      vertical = y;
    } else if (
      Math.abs(
        getFixTopY(root, this.app.screen, padding, this.app.screen.height) - y
      ) < pixelMathAllowance
    ) {
      vertical = 'top';
    } else if (
      Math.abs(
        getFixBottomY(root, this.app.screen, padding, this.app.screen.height) -
          y
      ) < pixelMathAllowance
    ) {
      vertical = 'bottom';
    } else if (
      Math.abs(getCenterY(root, this.app.screen) - y) < pixelMathAllowance
    ) {
      vertical = 'center';
    } else {
      vertical = y / this.app.screen.height;
    }

    return { horizontal, vertical };
  }

  getAbsolutePosition(
    root,
    { horizontal, vertical },
    padding = SCREEN_PADDING_PERCENT
  ) {
    let x, y;

    if (typeof horizontal === 'string') {
      x = getAlignX(
        root,
        this.app.screen,
        horizontal,
        padding,
        this.app.screen.height
      );
    } else {
      x = horizontal * this.app.screen.width;
    }

    if (typeof vertical === 'string') {
      y = getAlignY(
        root,
        this.app.screen,
        vertical,
        padding,
        this.app.screen.height
      );
    } else {
      y = vertical * this.app.screen.height;
    }

    return { x, y };
  }

  fitToHeight({ height, width }, newHeight) {
    return (width * newHeight) / height;
  }
}
